export const FiltroDescargaMasiva=Object.freeze({
    TODOS:"TODOS",
    INDIVIDUAL:"INDIVIDUAL",
});